import React, { useEffect } from "react";

import { LegalPopupLink } from "../components/LegalPopupLink";
import { SubscriptionForm } from "../components/SubscriptionForm";
import { privacyPolicyUrl, termsOfServiceUrl } from "../legal";

export function ProductionLandingPage() {
  useEffect(() => {
    document.title = "StanceKit | Voting guides, made clear";

    const description =
      "Import agendas, align organizational positions, and publish authoritative voter guides with StanceKit.";
    let metaDescription = document.querySelector<HTMLMetaElement>(
      'meta[name="description"]',
    );
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      document.head.append(metaDescription);
    }
    metaDescription.content = description;
  }, []);

  return (
    <div className="app-shell production-shell">
      <a className="skip-link" href="#main-content">
        Skip to main content
      </a>
      <header className="production-header">
        <div className="container production-header-inner">
          <a className="production-brand" href="/" aria-label="StanceKit home">
            STANCEKIT
          </a>
        </div>
      </header>
      <main id="main-content">
        <section
          className="production-landing"
          aria-labelledby="production-landing-title"
        >
          <div className="container production-landing-inner">
            <p className="production-kicker">Launching soon</p>
            <h1 id="production-landing-title">
              Turn agendas into clear voter guides.
            </h1>
            <p className="production-lead">
              Import proposals, align positions, and publish one authoritative
              guide.
            </p>
            <ol
              className="production-workflow"
              aria-label="How StanceKit works"
            >
              <li>Import</li>
              <li>Review</li>
              <li>Adopt</li>
              <li>Publish</li>
            </ol>
            <SubscriptionForm
              idPrefix="production-updates"
              label="Email address"
              buttonLabel="Join waitlist"
              placeholder="you@organization.org"
            />
          </div>
        </section>
      </main>
      <footer className="production-footer">
        <div className="container production-footer-inner">
          <p>
            © {new Date().getFullYear()} Asano Wharton, LLC. StanceKit is an
            independent service.
          </p>
          <nav aria-label="Legal links">
            <LegalPopupLink href={termsOfServiceUrl}>
              Terms of Service
            </LegalPopupLink>
            <LegalPopupLink href={privacyPolicyUrl}>
              Privacy Policy
            </LegalPopupLink>
          </nav>
        </div>
      </footer>
    </div>
  );
}
